var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3676_15124",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 22,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0032 3.99734H14.0019V2.99693C14.0019 1.8919 13.1061 0.996094 12.0011 0.996094H7.99943C6.8944 0.996094 5.99859 1.8919 5.99859 2.99693V3.99734H2.99734C1.3398 3.99734 -0.00390625 5.34105 -0.00390625 6.99859V16.0023C-0.00390625 17.6599 1.3398 19.0036 2.99734 19.0036H17.0032C18.6607 19.0036 20.0044 17.6599 20.0044 16.0023V6.99859C20.0044 5.34105 18.6607 3.99734 17.0032 3.99734ZM7.99943 2.99693H12.0011V3.99734H7.99943V2.99693ZM18.0036 16.0023C18.0036 16.5549 17.5557 17.0028 17.0032 17.0028H2.99734C2.44483 17.0028 1.99693 16.5549 1.99693 16.0023V10.39L6.67888 12.0007C6.7851 12.0151 6.89279 12.0151 6.99901 12.0007H13.0015C13.11 11.9987 13.2177 11.9818 13.3216 11.9507L18.0036 10.39V16.0023ZM18.0036 8.27913L12.8414 9.99984H7.15908L1.99693 8.27913V6.99859C1.99693 6.44608 2.44483 5.99818 2.99734 5.99818H17.0032C17.5557 5.99818 18.0036 6.44608 18.0036 6.99859V8.27913Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3676_15124)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.ab4d6b65c31bbc95b9959a5c44bd0c71.svg";
export { ForwardRef as ReactComponent };